import DifferentSection from './DifferentSection'

export default DifferentSection
